import React, {useState} from 'react';
import * as PropTypes from "prop-types";
import '../../resources/css/application.css';
import FormHelperText from "@material-ui/core/FormHelperText";

const EditDialog = (props) => {

    const {open, onChangeFieldValue, onClose, message, propertyName, fieldPlaceholder, fieldValidationMsg, fieldValidation} = props;
    const [newValue, setNewValue] = useState("");
    const [submitFlag, setSubmitFlag] = useState(false);

    const closeDialog = () => {
        setNewValue("");
        setSubmitFlag(false);
        onClose();
    };

    const submitDialog = () => {
        setSubmitFlag(true);
        if (fieldValidation(newValue)) {
            return;
        }
        onChangeFieldValue(propertyName, newValue);
        setNewValue("");
        setSubmitFlag(false);
        onClose();
    };

    return (
      <div>
          {open &&
          <div className="modal">
              <div className="modal-dialog modal-md modal-dialog-centered">
                  <div className="modal-content">

                      <div className="modal-header justify-content-center mb-5">
                          <h3 className="headline-3 text-center">{message}</h3>
                      </div>

                      <div className="modal-body justify-content-center mb-5">

                          <input
                            className={submitFlag && fieldValidation(newValue) ? "form-control has-error" : "form-control"}
                            type="text"
                            placeholder={fieldPlaceholder}
                            value={newValue}
                            onChange={(e) => setNewValue(e.target.value)}/>

                          <div className="error-text">
                              <FormHelperText error={submitFlag && fieldValidation(newValue)}>
                                  {submitFlag && fieldValidation(newValue) ? fieldValidationMsg : null}
                              </FormHelperText>
                          </div>

                      </div>

                      <div className="modal-footer justify-content-center">

                          <button type="button" data-dismiss="modal" aria-label="Close"
                                  className="btn btn--secondary btn--xs-full-width"
                                  onClick={() => closeDialog()}>Odustani
                          </button>

                          <button type="button" aria-label="Close"
                                  className="btn btn--primary btn--xs-full-width"
                                  onClick={() => submitDialog()}>Snimi
                          </button>

                      </div>
                  </div>
              </div>
          </div>
          }
      </div>
    );
};

EditDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onChangeFieldValue: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    message: PropTypes.string,
    propertyName: PropTypes.string,
    fieldPlaceholder: PropTypes.string,
    fieldValidationMsg: PropTypes.string.isRequired,
    fieldValidation: PropTypes.func.isRequired
};

export default EditDialog;